import Page from '../../../components/Page';
import useLocales from '../../../hooks/useLocales';
import Layout from '../../../layouts';
import TrafficSign from '../../../sections/gplx/TrafficSign';

Traffic.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function Traffic() {
  const { translate } = useLocales();
  return (
    <Page title={translate('sign.title')} description={translate('sign.description')}>
      <TrafficSign />
    </Page>
  );
}

